import React, { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { useAuth } from './AuthContext';

const SocketContext = createContext(null);

export const useSocket = () => {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error('useSocket must be used within a SocketProvider');
  }
  return context;
};

export const SocketProvider = ({ children, socket }) => {
  const [socketInstance, setSocketInstance] = useState(socket);
  const [isConnected, setIsConnected] = useState(false);
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (socket && !socketInstance) {
      setSocketInstance(socket);
    }
  }, [socket, socketInstance]);

  useEffect(() => {
    if (socketInstance) {
      socketInstance.on('connect', () => {
        setIsConnected(true);
        console.log('Socket connected');
      });

      socketInstance.on('disconnect', () => {
        setIsConnected(false);
        console.log('Socket disconnected');
      });

      return () => {
        if (socketInstance) {
          socketInstance.off('connect');
          socketInstance.off('disconnect');
        }
      };
    }
  }, [socketInstance]);

  const joinDocument = (documentId) => {
    if (socketInstance && isConnected) {
      socketInstance.emit('join-document', documentId);
    }
  };

  const leaveDocument = (documentId) => {
    if (socketInstance && isConnected) {
      socketInstance.emit('leave-document', documentId);
    }
  };

  const sendComment = (data) => {
    if (socketInstance && isConnected) {
      socketInstance.emit('new-comment', data);
    }
  };

  const updateDocument = (data) => {
    if (socketInstance && isConnected) {
      socketInstance.emit('document-updated', data);
    }
  };

  const value = {
    socket: socketInstance,
    isConnected,
    joinDocument,
    leaveDocument,
    sendComment,
    updateDocument,
  };

  return <SocketContext.Provider value={value}>{children}</SocketContext.Provider>;
};